export const faqData = [
  {
    id: 1,
    question: "Can I reduce my SBI Car Loan EMI after approval?",
    answer: "Yes, by making prepayments or opting for a longer tenure.",
  },
  {
    id: 2,
    question: "What is the minimum down payment required for an SBI Car Loan?",
    answer:
      "Typically 10%-20% of the car’s value. A higher down payment lowers EMI.",
  },
  {
    id: 3,
    question: "Can I get an SBI Car Loan with a low credit score?",
    answer:
      "Yes, but expect higher interest rates. A co-applicant can improve approval chances.",
  },
];
